export default "__VITE_ASSET__BmNcpxqQ__"